import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router'
import IntlMessages from '../../util/IntlMessages'
import {
  Card,
  Button,
  Input,
  Row,
  Col,
  Form,
  Collapse,
  Modal,
  Divider,
  Checkbox,
  DatePicker,
  Select,
  Skeleton,
  Table,
  message,
  Spin,
  Space
} from 'antd'
import {
  CloseOutlined,
  DeleteOutlined,
  EditOutlined,
  AccountBookFilled,
  UnorderedListOutlined,
  MailOutlined
} from '@ant-design/icons'
import { Tabs } from 'antd'
import ds from '../../Services/DataServices'
import moment from 'moment'
import { loadData } from '../../appRedux/actions/Setting'
import { useDispatch, useSelector } from 'react-redux'
import {
  setCommonConfigs,
  loadCustomerAddEditModalShow
} from '../../appRedux/actions/CommonData'
import AddEditCustomerModal from '../../components/AddEditCustomerModal'
import { CUSTOMER } from '../../constants/Pages'
import {
  isEmptyObject,
  checkRightspermissions,
  notAllowMsgCheck,
  getDecryptID,
  formatDigits,
  customParse
} from '../../appRedux/actions/GlobalMethods'
import { BEHAVIOUR_TYPE } from '../../Services/DataServices'
import { checkIsWeb } from '../../appRedux/actions/MobAppFn'
import NotAllowedComponent from '../../components/NotAllowedComponent'

const AddCustomer = props => {
  const Panel = Collapse.Panel
  const [form] = Form.useForm()
  const { TabPane } = Tabs
  const { TextArea } = Input
  const { Option } = Select
  const confirm = Modal.confirm
  const dispatch = useDispatch()
  const history = useHistory()

  const loadDataRedux = useSelector(({ settings }) => settings.loadData)
  const getReduxCommonSetting = useSelector(
    ({ commonConfigs }) => commonConfigs.pageCommonConfigs
  )
  const getDecimalPlaces = useSelector(
    ({ MainSale }) => MainSale.getDefaultDecimalPlaces
  )

  const [getCountryData, setgetCountryData] = useState([{ id: 0, label: '' }])
  const [getGroupData, setGroupData] = useState([{ id: '', label: '' }])
  const [getSearchGroupData, setSearchGroupData] = useState([
    { id: '', label: '' }
  ])
  const [getCustomerProfileData, setgetCustomerProfileData] = useState(null)
  const [getCustomerContactData, setgetCustomerContactData] = useState(null)
  const [getCustomerSId, setCustomerSId] = useState('')
  const [getCustomerList, setCustomerList] = useState([])
  // const [getCustomerListBackup, setCustomerListBackup] = useState([]);
  const [confirmLoading, setConfirmLoading] = useState(true)
  const [expand, setExpand] = useState(false)
  const [getIsSpinning, setIsSpinning] = useState(false)
  const [getCurrSymbol, setCurrSymbol] = useState('')
  const [Loader, setLoader] = useState(true)
  const [getPagination, setPagination] = React.useState({
    CurrentPageNo: 1,
    PageSize: 10,
    showSizeChanger: true
  })
  const [getIsDisableCreate, setIsDisableCreate] = useState(true)
  const [getIsDisableUpdate, setIsDisableUpdate] = useState(true)
  const [getIsDisableDelete, setIsDisableDelete] = useState(true)
  const [getIsAllowRead, setIsAllowRead] = useState(false)
  const [getAccessLoading, setAccessLoading] = useState(true)
  const [isDisable, setDisable] = useState(false)
  const [getRights, setRights] = useState([])
  const [getPermissions, setPermissions] = useState([])
  const [getCurrData, setCurrData] = useState({
    currencyCode: '',
    currencySymbol: ''
  })
  const [showSendAllReminder, setShowSendAllReminder] = useState(false)

  useEffect(() => {
    let mounted = true
    if (mounted) {
      setLoader(true)
      getCustomerListing(getPagination)
    }

    return () => (mounted = false)
  }, [loadDataRedux])

  useEffect(() => {
    dispatch(setCommonConfigs(CUSTOMER))
    getCusGroups()
  }, [])

  useEffect(() => {
    let mounted = true
    if (mounted) {
      if (getCustomerList && getCustomerList.length > 0) {
        if (
          getCustomerList.filter(a => a.account != '0.00' && a.customerEmail) &&
          getCustomerList.filter(a => a.account != '0.00' && a.customerEmail)
            .length > 0
        ) {
          setShowSendAllReminder(true)
        }
      }
    }
    return () => {
      mounted = false
    }
  }, [getCustomerList])

  //for common data -> store currency
  React.useEffect(() => {
    let mounted = true
    if (mounted) {
      const commonData = getReduxCommonSetting
      const respData =
        commonData &&
        commonData.storeCommonConfigs &&
        commonData.storeCommonConfigs.storeConfig
          ? commonData.storeCommonConfigs.storeConfig
          : {}
      if (respData && respData.currencyData) {
        let currencyData = respData.currencyData
        setCurrSymbol(currencyData.currencySymbol)
      }
      // rights && permissions
      if (commonData && commonData.storeCommonConfigs) {
        const rpData = checkRightspermissions(commonData)
        if (rpData && !isEmptyObject(rpData)) {
          setupRightsPermissions(rpData)
          setAccessLoading(false)
        } else {
          toInitialState()
          setAccessLoading(false)
        }
      }
    }

    return () => (mounted = false)
  }, [getReduxCommonSetting])

  function toInitialState () {
    setRights([])
    setPermissions([])
    setIsAllowRead(false)
    setIsDisableCreate(true)
    setIsDisableUpdate(true)
    setIsDisableDelete(true)
    setAccessLoading(true)
  }

  function setupRightsPermissions (rpData) {
    if (rpData.rights && rpData.rights.length > 0) {
      setRights(rpData.rights)
    } else {
      setRights([])
    }
    if (rpData.permissions && rpData.permissions.length > 0) {
      setPermissions(rpData.permissions)
    } else {
      setPermissions([])
    }
    if (rpData.read) {
      setIsAllowRead(true)
    } else {
      setIsAllowRead(false)
    }
    if (rpData.create) {
      setIsDisableCreate(false)
    } else {
      setIsDisableCreate(true)
    }
    if (rpData.update) {
      setIsDisableUpdate(false)
    } else {
      setIsDisableUpdate(true)
    }
    if (rpData.delete) {
      setIsDisableDelete(false)
    } else {
      setIsDisableDelete(true)
    }
  }

  async function getCusGroups () {
    const groupBody = {
      IsAll: true
    }
    const createReq = ds.listCustomerGroup(groupBody, BEHAVIOUR_TYPE.GET)
    await createReq
      .then(res => {
        let array = []
        if (res && res.length > 0) {
          array = res.map((data, index) => {
            return {
              id: data._CustomerSId.includes('&')
                ? data._CustomerSId.substring(0, data._CustomerSId.indexOf('&'))
                : data._CustomerSId,
              label: data.customerGroupName
            }
          })
        }
        setGroupData(array)
        // for only search
        // ;
        let all = { id: '-1', label: 'All' }
        array = array.concat(all)
        setSearchGroupData(array)
      })
      .catch(error => {
        notAllowMsgCheck(error)
        // console.log("cusGroups", error);
        // message.error("Some thing went wrong");
      })
  }

  async function getCustomerListing (body) {
    const createReq = ds.listCustomer(body, BEHAVIOUR_TYPE.GET)
    await createReq
      .then(res => {
        setLoader(false)
        setConfirmLoading(false)
        setIsSpinning(false)
        if (res && res.length > 0) {
          let array = res.map((data, index) => {
            return {
              key: index,
              customer: `${data.customerFirstName} ${data.customerLastName}`,
              customerSId: data.customerSId,
              contactNumber: data.contactNumber,
              storeCredit: data.storeCredit
                ? customParse(data.storeCredit)
                : '0.00',
              account: data.accountCredit
                ? customParse(data.accountCredit)
                : '0.00',
              loyalty: data.loyaltyValue
                ? customParse(data.loyaltyValue)
                : '0.00',
              totalEarnedLoyalty: data.totalLoyalty
                ? customParse(data.totalLoyalty)
                : '0.00',
              totalIssueCredit: data.totalStoreCredit
                ? customParse(data.totalStoreCredit)
                : '0.00',
              totalRedeemLoyalty: data.redeemedLoyalty
                ? customParse(data.redeemedLoyalty)
                : '0.00',
              totalRedeemCredit: data.redeemedCredit
                ? customParse(data.redeemedCredit)
                : '0.00',
              totalSpent:
                data.totalSpent > 0 ? customParse(data.totalSpent) : '0.00',
              yearlySpent:
                data.yearlySpent > 0 ? customParse(data.yearlySpent) : '0.00',
              isLoyaltyEnabled: data.IsLoyaltyEnabled,
              customerEmail: data.customerEmail,
              gender: data.gender,
              dob: data.dateOfBirth,
              id: data.customerSId,
              website: data.webSite,
              twitter: data.twitter,
              pPostalAddress:
                data.pPostalAddres || data.pPostalAddres2
                  ? `${data.pPostalAddres} ${data.pPostalAddres2}`
                  : '',
              postalAddress:
                data.postalAddres || data.postalAddres
                  ? `${data.postalAddres} ${data.postalAddres2}`
                  : '',
              customerCode: data.customerCode,
              groupName: data.groupName,
              groupId: data.customerGroupId
            }
          })
          let paginationobj = {
            CurrentPageNo: res && res.length > 0 ? res[0].currentPageNo : 1,
            PageSize: res && res.length > 0 ? res[0].pageSize : 10,
            total: res && res.length > 0 ? res[0].totalRecords : 0,
            showSizeChanger: true
          }
          setPagination(paginationobj)
          setCustomerList(array)
          if (props.match.params.options) {
            let a = props.match.params.options
            if (a && a.includes('groupId')) {
              let groupId = a.split('=')[1].toString()
              groupId = groupId.substring(0, groupId.indexOf('&'))
              const getArray = array.filter(
                item =>
                  item.groupId.substring(0, item.groupId.indexOf('&')) ===
                  groupId
              )
              form.setFieldsValue({ customerGroupSearch: groupId })
              setCustomerList(getArray)
            } else if (a && a.includes('cusID')) {
              let cusID = a.split('=')[1].toString()
              const cus = array.filter(
                item => getDecryptID(item.customerSId) == getDecryptID(cusID)
              )
              setCustomerList(cus)
            }
          }
        } else {
          setCustomerList([])
        }
      })
      .catch(error => {
        notAllowMsgCheck(error)
        setLoader(false)
        setIsSpinning(false)
        setConfirmLoading(false)
        // message.error("Some thing went wrong");
      })
  }

  async function getCustomerSearch (body) {
    const createReq = ds.getCustomerSearchService(body)
    await createReq
      .then(res => {
        if (res.data && res.data.data) {
          if (res.data.data.length > 0) {
            let cus = res.data.data
            let array = cus.map((data, index) => {
              return {
                key: index,
                customer: `${data.customerFirstName} ${data.customerLastName}`,
                customerSId: data.customerSId,
                contactNumber: data.contactNumber,
                storeCredit: data.storeCredit ? data.storeCredit : '0.00',
                account: data.accountCredit ? data.accountCredit : '0.00',
                loyalty: data.loyaltyValue ? data.loyaltyValue : '0.00',
                totalEarnedLoyalty: data.totalLoyalty
                  ? data.totalLoyalty
                  : '0.00',
                totalIssueCredit: data.totalStoreCredit
                  ? data.totalStoreCredit
                  : '0.00',
                totalRedeemLoyalty: data.redeemedLoyalty
                  ? data.redeemedLoyalty
                  : '0.00',
                totalRedeemCredit: data.redeemedCredit
                  ? data.redeemedCredit
                  : '0.00',
                totalSpent:
                  data.totalSpent && data.totalSpent > 0
                    ? data.totalSpent
                    : '0.00',
                yearlySpent:
                  data.yearlySpent && data.yearlySpent > 0
                    ? data.yearlySpent
                    : '0.00',
                isLoyaltyEnabled: data.IsLoyaltyEnabled,
                customerEmail: data.customerEmail,
                gender: data.gender,
                dob: data.dateOfBirth,
                id: data.customerSId,
                website: data.webSite,
                twitter: data.twitter,
                pPostalAddress:
                  data.pPostalAddres || data.pPostalAddres2
                    ? `${data.pPostalAddres} ${data.pPostalAddres2}`
                    : '',
                postalAddress:
                  data.postalAddres || data.postalAddres
                    ? `${data.postalAddres} ${data.postalAddres2}`
                    : '',
                customerCode: data.customerCode,
                groupName: data.groupName,
                groupId: data.customerGroupId
              }
            })
            setCustomerList(array)
          } else if (res.data.data.length < 1) {
            message.info('Customer not found ...', 4)
            setCustomerList([])
          }
        }
        setIsSpinning(false)
      })
      .catch(error => {
        setIsSpinning(false)
        setCustomerList([])
        // message.error("Some thing went wrong");
      })
  }

  async function sendAccEmailService (body, isAll) {
    if (!isAll) setConfirmLoading(true)
    else {
      message.info('Sending is in progress, will update after done.', 4)
      setDisable(true)
    }
    await ds
      .sendAccReminderEmail(body)
      .then(res => {
        setConfirmLoading(false)
        if (isAll) {
          setDisable(false)
          message.success(
            'Successfully sent to all customers of current page',
            5
          )
        } else {
          if (res) message.success('Sent Successfully')
          else message.error('Failed to send')
        }
      })
      .catch(e => {
        setDisable(false)
        setConfirmLoading(false)
      })
  }

  const handleTableChange = (pagination, filters, sorter) => {
    // setIsSpinning(true);
    setLoader(true)
    var body = getPagination
    body.CurrentPageNo = pagination.current
    body.PageSize = pagination.pageSize
    getCustomerListing(body)
  }

  const showConfirmDelete = (id, customerName) => {
    confirm({
      title: 'Delete ?',
      content: `"Are you sure you want to delete ${customerName}"`,
      okText: 'Yes',
      cancelText: 'No',
      okButtonProps: { className: 'dk-btn-add close-reg-btn' },
      cancelButtonProps: { className: 'dk-btn-cancel close-reg-btn' },
      onOk () {
        handleDelete(id)
      },
      onCancel () {
        //console.log('Cancel');
      }
    })
  }

  const handleDelete = id => {
    // setConfirmLoading(true);
    setLoader(true)
    ds.addCustomer({ BehaviorName: 2, CustomerSId: id }, BEHAVIOUR_TYPE.DELETE)
      .then(res => {
        // setConfirmLoading(false);
        dispatch(loadData(!loadDataRedux))
      })
      .catch(error => {
        notAllowMsgCheck(error)
        setLoader(false)
      })
  }

  const columns = [
    {
      title: <IntlMessages id='customerz.custable.col1' />,
      dataIndex: 'customer',
      key: 'customer',
      render: (text, record) => (
        <>
          <Row style={{ textAlign: 'left' }}>
            <Col span={12} lg={24} sm={24} xs={24}>
              <strong>{record.customer ? record.customer : ''}</strong>
              <span style={{ marginLeft: '5px' }} className='vd-flag sm:hidden'>
                {record.groupName
                  ? record.groupName.toString().toUpperCase()
                  : ''}
              </span>
            </Col>
          </Row>
          <Row style={{ textAlgin: 'left' }}>
            <Col span={12} lg={12} sm={12} xs={24}>
              <span style={{ fontSize: 'small' }}>
                <strong style={{ color: '#40a9ff' }}>
                  {record.customerCode}
                </strong>
              </span>
            </Col>
          </Row>
        </>
      )
    },
    {
      title: <IntlMessages id='customerz.custable.col2' />,
      dataIndex: 'loyalty',
      key: 'loyalty',
      render: (text, record) => {
        text = text ? formatDigits(text, getDecimalPlaces) : '0.00'
        return (
          <span>
            <strong
              style={{ color: '#41af4b' }}
            >{`${text} ${getCurrSymbol}`}</strong>
          </span>
        )
      }
    },
    {
      title: <IntlMessages id='customerz.custable.col3' />,
      dataIndex: 'storeCredit',
      key: 'storeCredit',
      render: (text, record) => {
        text = text ? formatDigits(text, getDecimalPlaces) : '0.00'
        return (
          <span>
            <strong
              style={{ color: '#41af4b' }}
            >{`${text} ${getCurrSymbol}`}</strong>
          </span>
        )
      }
    },
    {
      title: <IntlMessages id='customerz.custable.col4' />,
      dataIndex: 'account',
      key: 'account',
      render: (text, record) => {
        text = text ? formatDigits(text, getDecimalPlaces) : '0.00'
        return (
          <span>
            <strong
              style={{ color: '#d77173' }}
            >{`${text} ${getCurrSymbol}`}</strong>
          </span>
        )
      }
    }
  ]

  const onSearchFinish = values => {
    try {
      // ;
      setIsSpinning(true)
      let body = {
        keys: values.customerSearchTxt,
        GroupKey:
          values.customerGroupSearch == '-1' ? '' : values.customerGroupSearch
      }
      getCustomerSearch(body)
    } catch (e) {
      setIsSpinning(true)
      message.error('Problem, check connection...')
    }
  }

  const onSearchFinishFailed = errorInfo => {
    setIsSpinning(false)
    message.error('Kindly Attend to Missing Fields')
  }
  const redirectToImport = () => {
    history.push('/dashboard/customers/import')
  }
  const formFields = () => {
    const children = []
    children.push(
      <Col lg={12} span={12} sm={12} xs={24} style={{ display: 'block' }}>
        <Form.Item
          className='ant-form-item-label-custom'
          name={`customerSearchTxt`}
          label={<IntlMessages id='customerz.search.col1' />}
        >
          <Input placeholder='Search Customer by name' size='large' />
        </Form.Item>
      </Col>,
      <Col lg={12} span={12} sm={12} xs={24} style={{ display: 'block' }}>
        <Form.Item
          className='ant-form-item-label-custom'
          name={`customerGroupSearch`}
          label={<IntlMessages id='customerz.search.col2' />}
        >
          <Select
            size='large'
            showSearch={checkIsWeb().exist}
            optionFilterProp='children'
          >
            {getSearchGroupData &&
              getSearchGroupData.map((e, key) => {
                return (
                  <Select.Option key={key} value={e.id}>
                    {e.label}
                  </Select.Option>
                )
              })}
          </Select>
        </Form.Item>
      </Col>,
      <Col lg={8} span={8} sm={12} xs={24} style={{ display: 'block' }}>
        <div className='gx-form-row0'>
          <Form.Item
            className='ant-form-item-label-custom'
            name={`countrySearch`}
            label={'Country'}
          >
            <Select
              size='large'
              showSearch={checkIsWeb().exist}
              optionFilterProp='children'
            >
              {getCountryData &&
                getCountryData.length > 0 &&
                getCountryData.map((e, key) => {
                  return (
                    <Select.Option key={key} value={e.id}>
                      {e.label}
                    </Select.Option>
                  )
                })}
            </Select>
          </Form.Item>
        </div>
      </Col>,

      <Col lg={8} span={8} sm={12} xs={24} style={{ display: 'block' }}>
        <Form.Item
          className='ant-form-item-label-custom'
          name={'citySearch'}
          label={'City'}
        >
          <Input size='large' />
        </Form.Item>
      </Col>,
      <Col lg={8} span={8} sm={12} xs={24} style={{ display: 'block' }}>
        <Form.Item
          className='ant-form-item-label-custom'
          name={`dateCreatedSearch`}
          label={'Date Created'}
        >
          <DatePicker
            className='gx-mb-3 gx-w-100'
            size='large'
            inputReadOnly={true}
          />
        </Form.Item>
      </Col>
    )

    if (expand) {
      return children
    } else {
      return children.slice(0, 2)
    }
  }

  function sendReminderMail (isAll, info) {
    const data = { Customers: [] }
    if (isAll && getCustomerList && getCustomerList.length > 0) {
      getCustomerList.map(a => {
        if (a.customerEmail && a.customerSId) {
          const body = {
            ID: parseInt(getDecryptID(a.customerSId)),
            Email: a.customerEmail
          }
          data.Customers.push(body)
        }
      })
    } else {
      if (info && info.customerEmail && info.customerSId) {
        const body = {
          ID: parseInt(getDecryptID(info.customerSId)),
          Email: info.customerEmail
        }
        data.Customers.push(body)
      }
    }
    if (data.Customers && data.Customers.length > 0)
      sendAccEmailService(data, isAll)
  }

  return getIsAllowRead ? (
    <div className='Content-wrapper'>
      <Spin
        tip={<IntlMessages id='sell.cashlisting.cashloading' />}
        spinning={confirmLoading}
        size='large'
      >
        <div className='Customers-pg'>
          <Row className='back-arrow-h1 align-items-center justify-content-center mb-1 Customerspg-header mb-3'>
            <Col lg={12} md={12} sm={24} xs={24}>
              <h1 className='d-flex align-items-center mb-0'>
                <IntlMessages id='customer.addCustomer.title' />
              </h1>
              <p className=' custom-font-color-black'>
                <IntlMessages id='customer.addCustomer.helpDesc1' />
              </p>
            </Col>

            <Col lg={12} md={12} sm={24} xs={24}>
              <div className='text-right'>
                <Button
                  className=''
                  type='primary'
                  onClick={redirectToImport}
                  size='large'
                  disabled={getIsDisableCreate}
                >
                  <IntlMessages id='customer.addCustomer.importBut' />
                </Button>
                <Button
                  className='dk-btn-add'
                  type='primary'
                  onClick={() => {
                    setCustomerSId('')
                    dispatch(loadCustomerAddEditModalShow(true))
                  }}
                  size='large'
                  disabled={getIsDisableCreate}
                >
                  <IntlMessages id='customer.addCustomer.addBut' />
                </Button>
              </div>
            </Col>
          </Row>

          <Card
            className='gx-card mt-3 Filters-wrapper No-BoxShadow'
            title={<IntlMessages id='customerz.search.head' />}
          >
            <Form
              form={form}
              name={'searchForm'}
              // name="advanced_search"
              className=' product-search-form Filters-Form'
              layout='horizontal'
              initialValues={{
                customerGroupSearch: '-1',
                countrySearch: 'All Countries'
              }}
              onFinish={onSearchFinish}
              onFinishFailed={onSearchFinishFailed}
            >
              <Spin
                tip={<IntlMessages id='sell.cashlisting.cashloading' />}
                spinning={getIsSpinning}
                size='large'
              >
                <Row>{formFields()}</Row>

                <Col
                  span={24}
                  lg={24}
                  md={24}
                  xs={24}
                  sm={24}
                  className='text-right'
                >
                  <Space size='middle'>
                    <Form.Item>
                      <Button
                        type='primary'
                        className='dk-btn-clear-field'
                        onClick={() => {
                          form.resetFields()
                          getCustomerListing(getPagination)
                        }}
                      >
                        <IntlMessages id='sell.salehistory.clear' />
                      </Button>
                      <Button className='' type='primary' htmlType='submit'>
                        <IntlMessages id='sell.salehistory.search' />
                      </Button>
                    </Form.Item>
                  </Space>
                </Col>
              </Spin>
            </Form>
          </Card>

          <Row>
            <div
              className='custom-table-center'
              style={{ textAlign: 'center' }}
            ></div>

            <Col lg={24} md={24} sm={24} xs={24}>
              <div className='custom-product-table'>
                <Card className='noborder table-body'>
                  {getCustomerList && getCustomerList.length > 0 && (
                    <Row justify='space-between align-items-center mb-4'>
                      <Col lg={12} md={12} sm={24} xs={24}>
                        <p className='custom-font-color-black'>
                          <IntlMessages id='customer.list.showing' />
                          {` ${getCustomerList.length} `}
                          <IntlMessages id='customer.list.show' />
                        </p>
                      </Col>
                      {showSendAllReminder && (
                        <Col lg={12} md={12} sm={24} xs={24} className='text-right'>
                          <Button
                            className='dk-btn-add'
                            type='primary'
                            onClick={() => sendReminderMail(true)}
                            disabled={isDisable}
                          >
                            Send Reminder to all On Account Customers
                          </Button>
                        </Col>
                      )}
                    </Row>
                  )}
                  {false ? (
                    <Skeleton count={7} height={35} />
                  ) : (
                    <Table
                      className='gx-table-responsive MinWidth-auto'
                      columns={columns}
                      loading={Loader}
                      dataSource={getCustomerList}
                      expandedRowRender={record => {
                        return (
                          <div className='sub-table-box'>
                            <Row
                              key={record.key}
                              className='sub-table-box-header'
                            >
                              <Col xl={12} lg={24} md={24} sm={24} xs={24}>
                                <div>
                                  <h3 className='mb-0'>
                                    {
                                      <IntlMessages id='customer.addCustomer.expandCustomerData' />
                                    }
                                  </h3>
                                  <Divider
                                    style={{ backgroundColor: '#e5e5e5' }}
                                  />
                                  {record.gender || record.dob ? (
                                    <>
                                      {record.gender ? (
                                        <Row>
                                          <Col
                                            span={12}
                                            className='dk-font-size-customer'
                                          >
                                            <strong>
                                              {
                                                <IntlMessages id='customer.addCustomer.gender' />
                                              }
                                            </strong>
                                          </Col>
                                          <Col
                                            span={12}
                                            className='dk-font-size-customer'
                                          >
                                            {record.gender != '' &&
                                            record.gender.toLowerCase() == 'm'
                                              ? 'Male'
                                              : record.gender != '' &&
                                                record.gender.toLowerCase() ==
                                                  'f'
                                              ? 'Female'
                                              : record.gender != '' &&
                                                record.gender.toLowerCase() ==
                                                  'b'
                                              ? 'Non Binary'
                                              : ''}
                                          </Col>
                                        </Row>
                                      ) : null}
                                      {record.dob ? (
                                        <Row>
                                          <Col
                                            className='dk-font-size-customer'
                                            span={12}
                                          >
                                            <strong>
                                              {
                                                <IntlMessages id='customer.addCustomer.dob' />
                                              }
                                            </strong>
                                          </Col>
                                          <Col
                                            span={12}
                                            className='dk-font-size-customer'
                                          >
                                            {moment(record.dob).format(
                                              'YYYY-MM-DD'
                                            )}
                                          </Col>
                                        </Row>
                                      ) : null}
                                    </>
                                  ) : (
                                    <>
                                      <div style={{ textAlign: 'center' }}>
                                        {
                                          <IntlMessages id='customer.addCustomer.emptyCustomerProfileData' />
                                        }
                                      </div>
                                    </>
                                  )}
                                </div>
                                <div className='mt-5'>
                                  <h3 className='mb-0'>
                                    {
                                      <IntlMessages id='customer.addCustomer.expandCustomerContactData' />
                                    }
                                  </h3>
                                  <Divider
                                    style={{ backgroundColor: '#e5e5e5' }}
                                  />
                                  {record.customerEmail ||
                                  record.website ||
                                  record.twitter ||
                                  record.pPostalAddress ||
                                  record.contactNumber ||
                                  record.postalAddress ? (
                                    <>
                                      {record.contactNumber ? (
                                        <Row>
                                          <Col
                                            className='dk-font-size-customer'
                                            span={12}
                                          >
                                            <strong>
                                              <IntlMessages id='customer.addCustomer.contactNumber' />
                                            </strong>
                                          </Col>
                                          <Col
                                            span={12}
                                            className='dk-font-size-customer'
                                          >
                                            {record.contactNumber}
                                          </Col>
                                        </Row>
                                      ) : null}
                                      {record.customerEmail ? (
                                        <Row>
                                          <Col
                                            className='dk-font-size-customer'
                                            span={12}
                                          >
                                            <strong>
                                              <IntlMessages id='customer.addCustomer.email' />
                                            </strong>
                                          </Col>
                                          <Col
                                            span={12}
                                            className='dk-font-size-customer'
                                          >
                                            {record.customerEmail}
                                          </Col>
                                        </Row>
                                      ) : null}
                                      {record.website ? (
                                        <Row>
                                          <Col
                                            className='dk-font-size-customer'
                                            span={12}
                                          >
                                            <strong>
                                              <IntlMessages id='customer.addCustomer.website' />
                                            </strong>
                                          </Col>
                                          <Col
                                            className='dk-font-size-customer'
                                            span={12}
                                          >
                                            {record.website}
                                          </Col>
                                        </Row>
                                      ) : null}
                                      {record.twitter ? (
                                        <Row>
                                          <Col
                                            className='dk-font-size-customer'
                                            span={12}
                                          >
                                            <strong>
                                              <IntlMessages id='customer.addCustomer.twitter' />
                                            </strong>
                                          </Col>
                                          <Col
                                            className='dk-font-size-customer'
                                            span={12}
                                          >
                                            {record.twitter}
                                          </Col>
                                        </Row>
                                      ) : null}
                                      {record.postalAddress ? (
                                        <Row>
                                          <Col
                                            className='dk-font-size-customer'
                                            span={12}
                                          >
                                            <strong>
                                              <IntlMessages id='customer.addCustomer.postalAddressLabel' />
                                            </strong>
                                          </Col>
                                          <Col
                                            className='dk-font-size-customer'
                                            span={12}
                                          >
                                            {record.postalAddress}
                                          </Col>
                                        </Row>
                                      ) : null}
                                      {record.pPostalAddress ? (
                                        <Row>
                                          <Col
                                            className='dk-font-size-customer'
                                            span={12}
                                          >
                                            <strong>
                                              <IntlMessages id='customer.addCustomer.pyhsicalAddressLabel' />
                                            </strong>
                                          </Col>
                                          <Col
                                            className='dk-font-size-customer'
                                            span={12}
                                          >
                                            {record.pPostalAddress}
                                          </Col>
                                        </Row>
                                      ) : null}
                                    </>
                                  ) : (
                                    <>
                                      <div style={{ textAlign: 'center' }}>
                                        {
                                          <IntlMessages id='customer.addCustomer.emptyCustomerContactData' />
                                        }
                                      </div>
                                    </>
                                  )}
                                </div>
                              </Col>

                              <Col xl={8} lg={18} md={18} sm={24} xs={24}>
                                <h3 className='mb-0'>
                                  {
                                    <IntlMessages id='customer.addCustomer.expandCustomerBalanceData' />
                                  }
                                </h3>
                                <Divider
                                  style={{ backgroundColor: '#e5e5e5' }}
                                />

                                <div
                                  style={{
                                    display: 'flex',
                                    flexDirection: 'row'
                                  }}
                                >
                                  <Col
                                    className='dk-font-size-customer'
                                    span={12}
                                  >
                                    <strong>
                                      <IntlMessages id='customer.addCustomer.accountLabel' />
                                    </strong>
                                  </Col>
                                  <Col
                                    className='dk-font-size-customer'
                                    style={{ marginLeft: '40px' }}
                                    span={12}
                                  >
                                    <strong>
                                      {record.account ? record.account : '0.00'}
                                    </strong>
                                  </Col>
                                </div>
                                <div
                                  style={{
                                    display: 'flex',
                                    flexDirection: 'row'
                                  }}
                                >
                                  <Col
                                    className='dk-font-size-customer'
                                    span={12}
                                  >
                                    <IntlMessages id='customer.addCustomer.totalSpentLabel' />
                                  </Col>
                                  <Col
                                    className='dk-font-size-customer'
                                    style={{ marginLeft: '40px' }}
                                    span={12}
                                  >
                                    {record.totalSpent}
                                  </Col>
                                </div>
                                <div
                                  style={{
                                    display: 'flex',
                                    flexDirection: 'row'
                                  }}
                                >
                                  <Col
                                    className='dk-font-size-customer'
                                    span={12}
                                  >
                                    <IntlMessages id='customer.addCustomer.last12Months' />
                                  </Col>
                                  <Col
                                    className='dk-font-size-customer'
                                    style={{ marginLeft: '40px' }}
                                    span={12}
                                  >
                                    {record.yearlySpent}
                                  </Col>
                                </div>

                                <div
                                  style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    marginTop: 10
                                  }}
                                >
                                  <Col
                                    className='dk-font-size-customer'
                                    span={12}
                                  >
                                    <strong>
                                      <IntlMessages id='customer.addCustomer.storeCredit' />
                                    </strong>
                                  </Col>
                                  <Col
                                    className='dk-font-size-customer'
                                    style={{ marginLeft: '40px' }}
                                    span={12}
                                  >
                                    <strong>
                                      {record.storeCredit
                                        ? record.storeCredit
                                        : '0.00'}
                                    </strong>
                                  </Col>
                                </div>
                                <div
                                  className='dk-font-size-customer'
                                  style={{
                                    display: 'flex',
                                    flexDirection: 'row'
                                  }}
                                >
                                  <Col span={12}>
                                    <IntlMessages id='customer.addCustomer.totalIssue' />
                                  </Col>
                                  <Col
                                    className='dk-font-size-customer'
                                    style={{ marginLeft: '40px' }}
                                    span={12}
                                  >
                                    {record.totalIssueCredit}
                                  </Col>
                                </div>
                                <div
                                  style={{
                                    display: 'flex',
                                    flexDirection: 'row'
                                  }}
                                >
                                  <Col
                                    className='dk-font-size-customer'
                                    span={12}
                                  >
                                    <IntlMessages id='customer.addCustomer.totalRedeemed' />
                                  </Col>
                                  <Col
                                    className='dk-font-size-customer'
                                    style={{ marginLeft: '40px' }}
                                    span={12}
                                  >
                                    {record.totalRedeemCredit}
                                  </Col>
                                </div>

                                <div
                                  style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    marginTop: 10
                                  }}
                                >
                                  <Col
                                    className='dk-font-size-customer'
                                    span={12}
                                  >
                                    <strong>
                                      <IntlMessages id='customerz.search.loyal' />
                                    </strong>
                                  </Col>
                                  <Col
                                    className='dk-font-size-customer'
                                    style={{ marginLeft: '40px' }}
                                    span={12}
                                  >
                                    <strong>
                                      {record.loyalty ? record.loyalty : '0.00'}
                                    </strong>
                                  </Col>
                                </div>
                                <div
                                  className='dk-font-size-customer'
                                  style={{
                                    display: 'flex',
                                    flexDirection: 'row'
                                  }}
                                >
                                  <Col span={12}>
                                    <IntlMessages id='customerz.search.totlaearned' />
                                  </Col>
                                  <Col
                                    className='dk-font-size-customer'
                                    style={{ marginLeft: '40px' }}
                                    span={12}
                                  >
                                    {record.totalEarnedLoyalty}
                                  </Col>
                                </div>
                                <div
                                  style={{
                                    display: 'flex',
                                    flexDirection: 'row'
                                  }}
                                >
                                  <Col
                                    className='dk-font-size-customer'
                                    span={12}
                                  >
                                    <IntlMessages id='customer.addCustomer.totalRedeemed' />
                                  </Col>
                                  <Col
                                    className='dk-font-size-customer'
                                    style={{ marginLeft: '40px' }}
                                    span={12}
                                  >
                                    {record.totalRedeemLoyalty}
                                  </Col>
                                </div>
                              </Col>

                              <Col xl={4} lg={6} md={6} sm={24} xs={24}>
                                <div>
                                  <Button
                                    onClick={() => {
                                      let randomNbr = Math.floor(
                                        Math.random() * (999 - 100 + 1) + 100
                                      )
                                      let id =
                                        record.customerSId +
                                        randomNbr.toString()
                                      setCustomerSId(id)
                                      dispatch(
                                        loadCustomerAddEditModalShow(true)
                                      )
                                      //getDataForEdit(record.customerSId);
                                    }}
                                    disabled={getIsDisableUpdate}
                                    size='small'
                                    className='dk-btn-edit-expand dk-wd-auto dk-hgt-50 edit-text-btn'
                                    icon={
                                      <EditOutlined className='dk-btn-icon-align' />
                                    }
                                  >
                                    <IntlMessages id='customer.addCustomer.expandEditCustomerButton' />
                                  </Button>
                                </div>
                                <div>
                                  <Button
                                    size='small'
                                    className='dk-mg-tp-20 dk-btn-expand-view dk-wd-auto dk-hgt-50 inventory-text-btn'
                                    onClick={() =>
                                      history.push(
                                        `/dashboard/sell/salehistory/search/${record.customerSId}`
                                      )
                                    }
                                    icon={
                                      <UnorderedListOutlined className='dk-btn-icon-align' />
                                    }
                                    disabled={!getIsAllowRead}
                                  >
                                    <IntlMessages id='customer.addCustomer.expandViewSales' />
                                    {/* <Space size="small">
                                    <AccountBookFilled />
                                    {
                                      <IntlMessages id="customer.addCustomer.expandViewSales" />
                                    }
                                  </Space> */}
                                  </Button>
                                </div>
                                <div style={{ marginTop: '2px' }}>
                                  <Button
                                    className=' dk-mg-tp-20 dk-btn-expand-del dk-wd-auto dk-hgt-50'
                                    onClick={() =>
                                      showConfirmDelete(
                                        record.id,
                                        record.customer
                                      )
                                    }
                                    disabled={getIsDisableDelete}
                                    size='small'
                                    icon={
                                      <DeleteOutlined className='dk-btn-icon-align' />
                                    }
                                  >
                                    <IntlMessages id='customer.addCustomer.expandDelete' />
                                    {/* <Space size="small">
                                    <DeleteOutlined />
                                    {
                                      <IntlMessages id="customer.addCustomer.expandDelete" />
                                    }
                                  </Space> */}
                                  </Button>
                                </div>
                                {record.account && record.account != '0.00' && (
                                  <div style={{ marginTop: '2px' }}>
                                    <Button
                                      className='dk-btn-edit-expand dk-wd-auto dk-hgt-50 edit-text-btn'
                                      onClick={() => {
                                        if (record.customerEmail) {
                                          sendReminderMail(false, record)
                                        } else
                                          message.info(
                                            'Customer has not provided Email.',
                                            4
                                          )
                                      }}
                                      size='small'
                                      icon={
                                        <MailOutlined className='dk-btn-icon-align' />
                                      }
                                    >
                                      Send Reminder
                                    </Button>
                                  </div>
                                )}
                              </Col>
                            </Row>
                          </div>
                        )
                      }}
                      pagination={getPagination}
                      onChange={handleTableChange}
                      expandRowByClick
                    />
                  )}
                </Card>
              </div>
            </Col>
          </Row>
        </div>
        <AddEditCustomerModal id={getCustomerSId} />
      </Spin>
    </div>
  ) : (
    <NotAllowedComponent getAccessLoading={getAccessLoading} textType={1} />
  )
}

export default AddCustomer
